import { placeProject } from './project'
import request from './request'
import { QueryPageDto } from './dto'
import { config } from 'exceljs'

// 方案详情 - 人员名单（方案id） /rest/period-insur/staff-record/list-plan
export function getInsureDetailPersonnelList(data: { pageSize: number; pageNum: number; companyPlanId: string | number | string[]; insurStartTime: string; policyStatus?: number | string }): Promise<any> {
  return request.get('/rest/period-insur/staff-record/list-plan', {
    params: data
  })
}

/*
获取被派遣单位列表
!原 insure-dispatch.vue 日日保被派遣单位(暂时废弃) 引用了当前接口 先注释 不要删除
*/
// export function getDispatchList(data: { pageSize: number; pageNum: number; searchText?: string; status?: number; insurCompany?: string; planCode?: string; isGetFile: any; isGetArea?: any }): Promise<any> {
//   return request.get('/rest/period-insur/serve-company/list', {
//     params: data
//   })
// }

/*
提交被派遣单位
!原 insure-dispatch.vue 日日保被派遣单位(暂时废弃) 引用了当前接口 先注释 不要删除
*/
// export function addDispatch(data: { serveCompanyId: number; params: { video?: string; videos?: string[] } }): Promise<void> {
//   return request.post('/rest/period-insur/serve-company/add', data)
// }

// 获取被派遣单位
export function getDispatchExamine(data: { pageSize: number; pageNum: number; status: any }): Promise<any> {
  return request.get('/api/v1/pay/period-insur/serve-company/info', {
    params: data
  })
}

/*
派遣段位 取消 审核 接口
! path: '/insure/company' 被派遣单位(暂时废弃) 引用了当前接口 先注释 不要删除
*/

export function cancelDispatchExamine(data: { id: string }): Promise<void> {
  return request.post('/rest/period-insur/serve-company/cancelAudit', data)
}

// 派遣单位 删除 接口 /rest/period-insur/serve-company/delete
export function deleteDispatchExamine(data: { id: string }): Promise<void> {
  return request.post('/rest/period-insur/serve-company/delete', data)
}

// 获取单位列表 rest/pay/serve-company/list-to-pay data: any
/**
     */
export function getCompanyList(): Promise<any> {
  return request.get('/rest/pay/serve-company/list-to-pay')
}
export function getCompanyListParamApi(data: any): Promise<any> {
  return request.get('/rest/pay/serve-company/list-to-pay', {
    params:data
  })
}

// 被派遣单位列表信息 /rest/period-insur/serve-company/info
export function getCompanyDetailList(data: { pageNum: number; pageSize: number; status: number }): Promise<any> {
  return request.get('/rest/period-insur/serve-company/info', {
    params: data
  })
}

// 获取员工人员信息 /rest/period-insur/staff-record/list-staff
export function getStaffRecordList(data: { companyPlanId?: number; pageNum: number; pageSize: number; policyStatus?: string | number; searchText: string; insurCompany: string; insurValidFlag: boolean; insurEmptyEndDateFlag?: boolean; insurExistEndDateFlag?: boolean }): Promise<any> {
  return request.get('/rest/period-insur/staff-record/list-staff', {
    params: data
  })
}

export function getPeopleList(params: { pageNum: number; pageSize: number; searchText: string; policyStatus?: string }): Promise<any> {
  return request.get('/rest/period-insur/staff-record/list-staff', {
    params
  })
}

export function getPeopleListcopy(params: { pageNum: number; pageSize: number; searchText: string; policyStatus?: string }): Promise<any> {
  return request.get('/rest/period-insur/staff-record/out-danger-list-staff', {
    params
  })
}

// 投保 - 人员加保 /rest/period-insur/staff-record/ensure
export function insureAdd(data: any): Promise<any> {
  return request.post('/rest/period-insur/staff-record/ensure', data)
}

// 投保 减保前需要做校验 /rest/period-insur/staff-record/worker-insur-info
export function insureCheckReduce(data: any): Promise<any> {
  return request.post('/rest/period-insur/staff-record/worker-insur-info', data)
}

// 减保 /rest/period-insur/staff-record/terminal-ensure
export function insureReduce(data: any): Promise<void> {
  return request.post('/rest/period-insur/staff-record/terminal-ensure', data)
}

// 保险详情导出全部  /rest/period-insur/ensure-cost/export
export function insureDetailAllExport(params: { queryMonth: string; queryType: string; companyPlanId: any }): Promise<any> {
  return request.get('/rest/period-insur/ensure-cost/export', {
    params
  })
}

// 导出每日被保人员账单
export function exportperiodbill(params: { effectiveDate: string; companyPlanId: any }): Promise<any> {
  return request.get('/rest/period-insur/ensure-cost/export-period-bill', {
    params
  })
}

/**
 * 导出 安心保
 * @type billList 账单列表 ; staff 账单明细
 */
export function exportBillList(params: { queryStart: string; queryEnd: string; ensurePlanId?: number }, type: string): Promise<any> {
  const planParam = params.ensurePlanId ? `&ensurePlanId=${params.ensurePlanId}` : ''
  return request.post(
    `/isNew---/web/pc/pay/insure/bill/periodDailyFeeSummary/export${type}?queryStart=${params.queryStart}&queryEnd=${params.queryEnd}${planParam}`,
    {},
    {
      responseType: 'blob'
    }
  )
}

/**
 * 导出 安心保
 * @type billList 账单列表 ; staff 账单明细
 */
export function exportCompanyBillList(params: { queryStart: string; queryEnd: string; companyPlanId: string | string[]; ensurePlanId?: number }, type: string): Promise<any> {
  return request.post(
    `/isNew---/web/pc/pay/insure/bill/periodDailyFeeSummary/export${type}?queryStart=${params.queryStart}&queryEnd=${params.queryEnd}&companyPlanId=${params.companyPlanId}&ensurePlanId=${params.ensurePlanId}`,
    {},
    {
      responseType: 'blob'
    }
  )
}

/**
 * 导出 安心保-人员名单
 */
export function exportWorkerList(params: { searchText: string; policyStatus: string }): Promise<any> {
  return request.get(`/isNew---/web/pc/pay/insurePeriodStaffRecord/exportStaffList?searchText=${params.searchText}&policyStatus=${params.policyStatus}`, {
    responseType: 'blob'
  })
}

// 查询账单列表
export function getEnsureCostListapi(params: { queryStart: string; queryEnd: string; pageSize: string | number; pageNum: string | number }): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insure/bill/periodDailyFeeSummary/list', {
    params
  })
}

// 保费趋势
export function getMoneyTrend(
  params: void
): Promise<
  {
    ensureDay: string
    money: number
    peopleCount: number
  }[]
> {
  return request.get('/rest/period-insur/ensure-cost/insur-cost-trend', {
    params
  })
}

export interface PlanStatisticsDto {
  occupationGroup: { count: number; occupationName: string }[]
  serveCompanyGroup: { count: number; serveCompanyName: string }[]
}

export interface planTermsDataDto {
  id?: number
  insureCompanyId?: number
  name?: string
  code?: string
  dictValue?: string
  createUserId?: number
  updateUserId?: number
  createTime?: string
  updateTime?: string
  nickName?: string
}


export interface replaceCountInfoDto {
  canReplaceCount?: number
  alreadyReplaced?: number
  totalReplaceQuota?: number
}
// 多场景异常接口返回状态
export interface ResDto {
  code: number
  msg: string
}

// 校验身份证
export interface IdCardNoVerifyDto {
  companyPlanId?: number
  workerInfoList: [
    {
      index?: number | undefined
      userName: string
      idCardNo: string | number
      msg?: string | undefined
    }
  ]
  // userName: string
  // idCardNo: string
  // msg?: string
  // index?: number
}

export interface IdCardNoVerifyDtoTwo {
  index?: number | undefined
  userName: string
  idCardNo: string | number
  msg?: string | undefined
}

export interface ReIdCardNoVerifyDto {
  correctList: []
  errorList: [{ userName: string; idCardNo: string; errMsg: string }]
}

// userName: string
// idCardNo: string
// msg?: string
// index?: number

export interface addListInformation {
  occupationName?: string
  serveCompanyName: string
  userName: string
  serveCompanyId?: number | string
  idCardNo: string
  occupationId?: number | undefined | string
  occupationList?: any
  joinType?: number | null
  level?: number | string | undefined
  index?: number | null
  errMsg?: string
}

export interface IdCardNoVerifyResDto extends ResDto {
  data: ReIdCardNoVerifyDto
}

export function checkoutIdCardNoList(data: IdCardNoVerifyDto): Promise<ReIdCardNoVerifyDto> {
  return request.post('/rest/period-insur/staff-record/worker-insur-info', data)
}

export function checkoutIdCardNoListTwo(data: IdCardNoVerifyDtoTwo[]): Promise<any> {
    data.push({
        userName: '',
        idCardNo: '杜创'
    })
  return request.post('/rest/common/batchIdCardNoVerify', data, {
    headers: {
        crypto: 'crypto'
    }
  })
}

// 检测续保条件
export function testingInsure(data: {
  companyPlanId: number | string
  insurStartDay: string
  staffList: any
}): Promise<{
  price?: number
  priceFour?: number
  priceFive?: number
  needCreateCount?: number
  deductionCount?: number
  needCostFeeMonth?: number
  tomorrowNeedCostFee?: number
  currentBalance?: number
  willEnsureCostFee?: number
  errorList?: any
  isSuccess: boolean
}> {
  return request.post('/rest/period-insur/staff-record/ensure-before-check', data)
}

// 检测是否月底
export function renewalMonthNotify(data: { planId: string | string[] }): Promise<any> {
  return request.get('/rest/period-insur/staff-record/onekey-renewal-month-notify', {
    params: data
  })
}

export interface disposableTransposing {
  insurStartDay?: string
  staffList: [
    // eslint-disable-next-line no-use-before-define
    disposableTransposingArr
  ]
}

export interface disposableTransposingArr {
  // 输出接口BillDto的接口
  id: number // 要换厂的人员列表id
  idCardNo: string // 人员身份证
  occupationId: number // 工种id（客户要换厂的工种id）
  occupationName: string // 工种名（客户要换厂的工种名）
  serveCompanyId: number // 被派遣单位id（要换厂的id）
  serveCompanyName: string // 被派遣单位名称（要换厂的名称）
  userName: string // 用户名
  insurStartDay?: string | undefined
}

// 安心保工对工充值 接口
export function addLongTermRecharge(data: any): Promise<any> {
  return request.post('/rest/company/period-recharge', data, {
    headers: {
        allResponse: 'allResponse'
    }
  })
}

// 获取安心保公司保险方案
export function longQueryPlans(): Promise<any> {
  return request.get('/insur/InsurComCompanyPlans/query-plans')
}

// 获取安心保 充值记录列表
export function longBillRecord(data: QueryPageDto): Promise<any> {
  return request.get('/rest/company/period-recharge-list', {
    params: data
  })
}
// insure-module-export/period-recharge-list-export 导出安心保账单

export function periodRechargeListExport(data: any): Promise<any> {
  return request.get('insure-module-export/period-recharge-list-export', {
    params: data
  })
}
// 检测保险是否可以批量投保
export function checkStatusPeriod(): Promise<any> {
  return request.get('/insur-com-company/insur-com-company/check-status-period')
}

// 获取被派遣单位详情信息
export function applyOccupation(data: any): Promise<any> {
  return request.post('/rest/period-insur/serve-company-occupation', data)
}

// 撤销工种记录
export function deleteOccupation(id: number): Promise<any> {
  return request.delete(`/rest/period-insur/serve-company-occupation/${id}`)
}

// 获取保险商品列表（insureType: 2=安心保 8=安心日保）
export function getInsureEnsurePlanListApi(data: { insureType: number }): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insureEnsurePlan/planList', { params: data })
}
